import { render, staticRenderFns } from "./px-navigation-step.vue?vue&type=template&id=0454705a&scoped=true&"
import script from "./px-navigation-step.vue?vue&type=script&lang=ts&"
export * from "./px-navigation-step.vue?vue&type=script&lang=ts&"
import style0 from "./px-navigation-step.vue?vue&type=style&index=0&id=0454705a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0454705a",
  null
  
)

export default component.exports